/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  var blockedVariantIds = new Set([
    '53988275355996',
    '42539550605528',
    '42564869488856',
    '42564869521624'
  ]);
  var blockedProductHandles = new Set([
    'lashlift-effect-mascara',
    'lashlift-effect-mascara-flerpack'
  ]);

  function isBlockedValue(value) {
    if (value === null || typeof value === 'undefined') {
      return false;
    }

    if (Array.isArray(value)) {
      return value.some(isBlockedValue);
    }

    if (typeof value === 'object') {
      return Object.keys(value).some(function (key) {
        return isBlockedValue(value[key]);
      });
    }

    return blockedVariantIds.has(String(value));
  }

  function bodyContainsBlockedVariant(body) {
    if (!body) {
      return false;
    }

    if (typeof body !== 'string') {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return Array.from(body.values()).some(isBlockedValue);
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return Array.from(body.values()).some(isBlockedValue);
      }

      return isBlockedValue(body);
    }

    try {
      return isBlockedValue(JSON.parse(body));
    } catch (error) {
      return Array.from(new URLSearchParams(body).values()).some(isBlockedValue);
    }
  }

  function forceSoldOutState() {
    var soldOutText = window.languages && window.languages.productFormSoldOut
      ? window.languages.productFormSoldOut
      : 'Slutsåld';
    var forcedSections = document.querySelectorAll('[data-lf-hg3-stockout="true"]');

    forcedSections.forEach(function (section) {
      section.querySelectorAll('.ProductForm__AddToCart').forEach(function (button) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.removeAttribute('data-action');
        button.classList.remove('Button--primary');
        button.classList.add('Button--secondary');
        if (button.textContent.trim() !== soldOutText) {
          button.textContent = soldOutText;
        }
      });

      section.querySelectorAll('.shopify-payment-button, .ProductForm__QuantitySelector').forEach(function (element) {
        element.style.display = 'none';
      });
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var variantInput = form.querySelector('[name="id"]');

      if (variantInput && blockedVariantIds.has(String(variantInput.value))) {
        form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-disabled', 'true');
        });
      }
    });

    document.querySelectorAll('.ProductItem').forEach(function (card) {
      var productLink = card.querySelector('.ProductItem__Title a[href*="/products/"]');
      var handleMatch = productLink && productLink.getAttribute('href').match(/\/products\/([^/?#]+)/);

      if (!handleMatch || !blockedProductHandles.has(handleMatch[1])) {
        return;
      }

      card.querySelectorAll('.incubate-collections-add-to-cart-add-to-cart-button').forEach(function (button) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        if (button.textContent.trim() !== soldOutText) {
          button.textContent = soldOutText;
        }
      });
    });
  }

  function cartContainsBlockedProduct() {
    return document.querySelector('[data-lf-hg3-stockout-cart="true"]') !== null;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (form.matches('form[action*="/cart/add"]')) {
      var variantInput = form.querySelector('[name="id"]');

      if (variantInput && blockedVariantIds.has(String(variantInput.value))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        forceSoldOutState();
        return;
      }
    }

    if (cartContainsBlockedProduct() && form.querySelector('[name="checkout"], [href$="/checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!cartContainsBlockedProduct()) {
      return;
    }

    var checkoutControl = event.target.closest(
      '[name="checkout"], [href$="/checkout"], [href$="checkout"], .additional-checkout-button'
    );

    if (checkoutControl) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('variant:changed', forceSoldOutState);
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(forceSoldOutState, 0);
  });
  document.addEventListener('product:added', function () {
    window.setTimeout(forceSoldOutState, 0);
  });

  if (window.fetch) {
    var nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;

      if (url && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && init && bodyContainsBlockedVariant(init.body)) {
        return Promise.resolve(new Response(JSON.stringify({
          status: 422,
          description: window.languages && window.languages.productFormSoldOut
            ? window.languages.productFormSoldOut
            : 'Slutsåld'
        }), {
          status: 422,
          headers: {'Content-Type': 'application/json'}
        }));
      }

      return nativeFetch(input, init);
    };
  }

  document.addEventListener('DOMContentLoaded', forceSoldOutState);

  new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return mutation.addedNodes.length > 0;
    })) {
      forceSoldOutState();
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();